import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ArrowIcon from "@material-ui/icons/SwapHoriz";
import MyCard from "./MyCard";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import SaveIcon from "@material-ui/icons/SaveRounded";
import CloseIcon from "@material-ui/icons/CloseOutlined";
import PhotoCamera from "@material-ui/icons/PhotoCameraOutlined";
import KeyboardIcon from "@material-ui/icons/KeyboardOutlined";
import GameIcon from "@material-ui/icons/VideogameAsset";
import HighlightIcon from "@material-ui/icons/HighlightOutlined";
import CopyIcon from "@material-ui/icons/FileCopyOutlined";
import SearchIcon from "@material-ui/icons/SearchOutlined";
import HelpIcon from "@material-ui/icons/HelpOutlineRounded";
import NavigateNext from "@material-ui/icons/NavigateNext";
import MenuIcon from "@material-ui/icons/Translate";
import CardActions from "@material-ui/core/CardActions";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import WordComponent from "./WordComponent";
import ProgressLine from "./ProgressLine";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import {
  Snackbar,
  Card,
  InputAdornment,
  Tooltip,
  Divider,
  List,
  ListItem,
  Avatar,
  ListItemText,
  Chip,
  CardContent,
  LinearProgress,
  Switch,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TableRow,
  TableHead,
  Table,
  TableCell,
  TableBody,
  Fab
} from "@material-ui/core";
import WordSuggest from "./WordSuggest";
import { AppContext } from "../App";
import {
  FireBaseUI,
  FireBaseUIConfig,
  clearWord,
  buildEditableHtml,
  setEndOfContenteditable,
  copyElemText,
  countWords,
  stringToArray,
  modifyContent,
  clog,
  wrong_words_array,
  lastWord,
  chars2Num,
  getWordOnCursor,
  shortenWord,
  assameseBindings,
  toolbarOptions,
  removeElementsByClass,
  KEY_MAP
} from "../AppClass";
import { FetchData, HOSTNAME } from "../services/FetchData";
import LoginPage from "./LoginPage";
import MyAppBar from "./MyAppBar";
import MyFooter from "./MyFooter";
import { Redirect } from "react-router-dom";
//import {Editor, EditorState, RichUtils, ContentState, convertFromRaw, convertToRaw} from "draft-js";
import ReactContentEditable from "./react-simple-contenteditable";
//import ContentEditable from "react-contenteditable";
import $ from "jquery";
//import tippy from "tippy.js";
//import "tippy.js/index.css";
//import "tippy.js/themes/light-border.css";
//import { Tensor, InferenceSession } from "onnxjs";

/*
import rangy from "rangy";
import rangyHighlight from "rangy/lib/rangy-highlighter";
import rangyClassApplier from "rangy/lib/rangy-classapplier";
import rangyTextRange from "rangy/lib/rangy-textrange";
import rangySerializer from "rangy/lib/rangy-serializer";
import mark from "mark.js/src/lib/mark";
*/

// Import the Slate editor.
//import { Editor } from "slate-react";
//import { Value } from "slate";

import MyAutoSuggest from "./MyAutoSuggest";

import {
  MuiThemeProvider,
  createMuiTheme,
  FormControlLabel
} from "@material-ui/core/es";
import { mui_theme } from "../AppClass";

import firebase from "firebase/app";
import { fbdb } from "../AppClass";
import SupportPage from "./SupportPage";
import MyNotes from "./MyNotes";
import Payment from "./Payment";
import MyDialog from "./MyDialog";

import { Link } from "react-router-dom";

import Quill from "quill";
//import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
//import "quill/dist/quill.bubble.css";
import Delta from "quill-delta/lib/delta";

import { log } from "../AppClass";

//import * as tf from "@tensorflow/tfjs";

// Create our initial value...
// const initialValue = Value.fromJSON({
//   document: {
//     nodes: [
//       {
//         object: "block",
//         type: "paragraph",
//         nodes: [
//           {
//             object: "text",
//             leaves: [
//               {
//                 text: "A line of text in a paragraph."
//               }
//             ]
//           }
//         ]
//       }
//     ]
//   }
// });

// Define a React component renderer for our code blocks.
function CodeNode(props) {
  return (
    <pre {...props.attributes}>
      <code>{props.children}</code>
    </pre>
  );
}

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  inputStyle: {
    display: "none"
  }
});

function StateLessWidget() {
  return <div contentEditable={true}>Hello</div>;
}

class CenteredGrid extends React.Component {
  constructor(props) {
    super(props);
    //this.state = {editorState: EditorState.createEmpty()};
    //this.onChange = (editorState) => this.setState({editorState});
    //this.state.editorState = EditorState.createEmpty()

    this.myRef = React.createRef();

    this.contentChange = this.contentChange.bind(this);
  }

  state = {
    auth_token:
      localStorage.getItem("auth_token") !== null
        ? localStorage.getItem("auth_token")
        : Math.random(),

    inputText: "", //"আমি দৈনন্দিন জীৱনত ব্যৱহাৰ কৰা যন্ত্ৰসমূহৰ \nএটা প্ৰধান বৈশিষ্ট্য এইয়ে যে, যন্ত্ৰসমূহক সদায় এটা নিৰ্দিষ্ট কাম কৰিবলৈ নিৰ্দেশনা দি থকাৰ প্ৰয়োজন হয়। উদাহৰণস্বৰূপে, কম্পিউটাৰ, মোবাইল, ইত্যাদিয়ে ব্যৱহাৰকাৰীয়ে দিয়া নিৰ্দেশবোৰ এটাৰ পিছত এটাকৈ সমাধান কৰে।",
    inputCharLength: 0,
    inputWordsNum: 0,
    wordsMap: [],

    outputText: "",
    outputCharLength: 0,

    menuOpen: false,

    openSnack: false,
    vertical: "top",
    horizontal: "center",
    snackMessage: "",

    openSuggest: false,
    suggestAnchor: null,

    redirect: false,

    //editorState: EditorState.createWithContent(ContentState.createFromText(''))
    //editorState: EditorState.createEmpty(),
    html: "",
    //html: "আমি <u>দৈনন্দিন</u> জীৱনত hello <span>ব্যৱহাৰ</span> কৰা <b>যন্ত্ৰসমূহৰ</b> এটা প্ৰধান বৈশিষ্ট্য এইয়ে যে, যন্ত্ৰসমূহক সদায় এটা নিৰ্দিষ্ট কাম কৰিবলৈ নিৰ্দেশনা দি থকাৰ প্ৰয়োজন হয়।",

    serverResponse: [],
    response: [],
    wrong_words: [], //["hello", "world", "অসম"],

    submitting: false,

    clickedWord: "",
    suggestedWords: [],
    suggestLoading: false,
    tabSuggestionWord: 0,

    spell_checked: false,

    title: "", //"<div class='placeholderClass'>ইয়াত অসমীয়াত লিখক<br />Type Assamese here</div>",

    rangyPrevState: null,

    //value: initialValue,

    noMatch: true,

    search_term: "",

    dialogOpen: false,

    quillEditorState: null,
    firstQuillType: false,
    modelState: null,

    wordStartIndex: null,
    wordEndIndex: null,

    keyboardType: false, //phonetic / default
    quillCursorIndex: 0,

    openKeyDialog: false
  };

  // On change, update the app's React state with the new editor value.
  onSlateChange = ({ value }) => {
    this.setState({ value });
    this.doSearch();
  };

  // Add a `renderNode` method to render a `CodeNode` for code blocks.
  renderNode = (props, editor, next) => {
    switch (props.node.type) {
      case "code":
        return <CodeNode {...props} />;
      default:
        return next();
    }
  };

  onKeyDown = (event, editor, next) => {
    //if (event.key !== '&') return next()
    //event.preventDefault()
    //editor.insertText('and')

    if (event.key !== "`" || !event.ctrlKey) return next();
    event.preventDefault();

    // Determine whether any of the currently selected blocks are code blocks.
    const isCode = editor.value.blocks.some(block => block.type === "code");
    // Toggle the block type depending on `isCode`.
    editor.setBlocks(isCode ? "paragraph" : "code");
  };

  //simple react-contenteditable change
  contentChange(ev, value) {
    //console.log(/\n$/.test(value), ev)
    const containerElement = document.getElementById("simpleEditable");

    //let savedSel = rangy.getSelection().saveCharacterRanges(containerElement);
    //let savedSel = rangy.getSelection().getAllRanges()
    console.log(value);

    // this.setState({
    //   rangyPrevState: savedSel,
    //   inputCharLength: value.length
    // });

    this.setState(
      {
        title: modifyContent(value)
      },
      () => {
        this.doSearch();
        //containerElement.focus();
        //rangy.getSelection().restoreCharacterRanges(containerElement, savedSel);

        //containerElement.click()
        //containerElement.focus()

        // if (savedSel && savedSel.length > 0) {
        //   //rangy.getSelection().setRanges(savedSel);
        // }
      }
    );

    // setTimeout(function () {
    //     rangy.getSelection().restoreCharacterRanges(containerElement, savedSel);
    //     document.getElementById("simpleEditable").focus()
    // }, 50);
  }

  contentKeyUp(e) {
    const typedText = e.target.innerText;
    const event_type = e.type;

    document.getElementById("input-length").innerHTML =
      typedText.length + " / 3000";

    this.setState({
      inputText: typedText,
      inputCharLength: typedText.length,
      inputWordsNum: countWords(typedText),
      wordsMap: stringToArray(typedText),

      //editorState: EditorState.createWithContent(ContentState.createFromText(typedText))
      //html: typedText //HTML

      //serverResponse: [],

      openSuggest: false
    });

    //this.onnx_js()

    if (stringToArray(typedText).length > 100) {
      this.setState({
        //openSnack: true,
        //snackMessage: "Exceeded 100 words limit."
      });
    }

    if (typedText.length > 3000) {
      this.setState({
        openSnack: true,
        snackMessage: "Exceeded 3000 character limit."
      });
      return false;
    } else {
      this.setState({
        openSnack: false
      });
    }

    if (event_type === "input") {
      return false;
    }

    const keycode = e.keyCode;

    console.log("contentKeyUp", keycode, typedText, e.type);

    if (keycode === 27) {
      console.log("escape");
      this.spellCheckButtonClick();
      //return false
    }

    if (keycode === 13 || keycode === 8 || keycode === 38 || keycode === 40) {
      //e.preventDefault()
      return;
    }

    this.maintainCursor();

    //containerElement.click()
    //containerElement.focus()
  }

  maintainCursor() {
    //const containerElement = document.getElementById("simpleEditable");
    //let savedSel = rangy.getSelection().saveCharacterRanges(containerElement);
    //this.doSearch();
    //rangy.getSelection().restoreCharacterRanges(containerElement, savedSel);
  }

  contentMouseOver = elem => {
    //console.log(elem.target.className, elem.target.innerText)

    if (elem.target.className === "redUnderline") {
      this.suggestionMenuOpen(elem, elem.target.innerText);

      // tippy('.redUnderline', {
      //     //target: '.childClass',
      //     content: document.getElementById("tippydiv").innerHTML,
      //     allowHTML: true,
      //     arrow: true,
      //     theme: 'light-border',
      //     animation: 'shift-away',
      //     animateFill: false,
      //     interactive: true,
      //     placement: 'bottom',
      //     delay: [300, 0],
      //     onShow: function (tip) {
      //         tip.setContent(document.getElementById("tippydiv").innerHTML)
      //     },
      //     distance: 12,
      // })
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    //const collection = tippy('.redUnderline', { content: 'Tooltip' })
  }

  onChange = editorState => {
    //console.log(convertToRaw(editorState.getCurrentContent()));
    this.setState({
      //editorState: editorState
      //editorState: EditorState.createWithContent(ContentState.createFromText(this.state.inputText))
    });
  };

  handleKeyCommand = (command, editorState) => {
    // const newState = RichUtils.handleKeyCommand(editorState, command);
    // if (newState) {
    //     this.onChange(newState);
    //     return "handled";
    // }
    // return "not-handled";
  };

  // onnx_js = () => {
  //   //TODO
  //   const session = new InferenceSession();
  //   // use the following in an async method
  //   const url = "/model/torch_model.onnx";
  //   //async session.loadModel(url);

  //   session.loadModel(url).then(() => {
  //     //creating an array of input Tensors is the easiest way. For other options see the API documentation
  //     const inputs = [
  //       new Tensor(new Float32Array([[1.0]]), "float32", [1, 1, 1])
  //     ];

  //     // generate model input
  //     const inferenceInputs = inputs;
  //     // execute the model
  //     session.run(inferenceInputs).then(output => {
  //       // consume the output
  //       const outputTensor = output.values().next().value;
  //       console.log(`onnx.js model output tensor: ${outputTensor.data}.`);
  //     });
  //   });
  // };

  handleChange = (event, io) => {
    let typedText = event.target.value;

    if (io === "input") {
      this.setState({
        inputText: typedText,
        inputCharLength: typedText.length,
        inputWordsNum: countWords(typedText),
        wordsMap: stringToArray(typedText),

        //editorState: EditorState.createWithContent(ContentState.createFromText(typedText))
        //html: typedText //HTML

        serverResponse: [],

        openSuggest: false
      });

      //this.onnx_js()

      if (stringToArray(typedText).length > 100) {
        this.setState({
          //openSnack: true,
          //snackMessage: "Exceeded 100 words limit."
        });
      }

      if (typedText.length > 3000) {
        this.setState({
          openSnack: true,
          snackMessage: "Exceeded 3000 character limit."
        });
        return false;
      } else {
        this.setState({
          openSnack: false
        });
      }
    } else {
      this.setState({
        outputText: typedText,
        outputCharLength: typedText.length
      });
    }

    //stop ajax
    return false;

    FetchData("/spellcheck", {
      //email: localStorage.getItem("user_mail") === null ? "" : localStorage.getItem("user_mail"),
      token:
        localStorage.getItem("auth_token") === null
          ? ""
          : localStorage.getItem("auth_token"),
      text: typedText
    })
      .then(result => {
        console.log("/spellcheck", result);

        let jsonResult = JSON.parse(JSON.stringify(result));

        //console.log(typedText, io, typedText.length);
        let wordMap = this.stringToArray(typedText);
        //console.log('word array ', wordMap)
        let HTML = "";
        for (var i = 0; i < wordMap.length; i++) {
          console.log(jsonResult[i]);
          if (jsonResult[i] === 0) {
            HTML = HTML + "<mark>" + wordMap[i] + " </mark>";
          } else {
            HTML = HTML + "<span>" + wordMap[i] + " </span>";
          }
        }
      })
      .catch(error => {
        //alert(error);
        console.log("/spellcheck", error);
      });
  };

  suggestionMenuOpen = (e, word) => {
    //alert(word)
    this.setState({
      //menuOpen: !state.menuOpen,
      //inputText: word,
      clickedWord: word,
      suggestAnchor: e.target, //e.currentTarget,
      openSuggest: true,
      suggestedWords: [],

      suggestLoading: true
    });

    return;

    FetchData("/suggest", {
      token:
        localStorage.getItem("auth_token") === null
          ? ""
          : localStorage.getItem("auth_token"),
      //email: localStorage.getItem("user_mail") === null ? "" : localStorage.getItem("user_mail"),
      word: clearWord(word)
    })
      .then(result => {
        console.log("/suggest", result);

        let jsonResult = JSON.parse(JSON.stringify(result));
        //console.log(jsonResult)
        this.setState({ suggestedWords: jsonResult, suggestLoading: false });
      })
      .catch(error => {
        //alert(error);
        console.log("/suggest", error);
        this.setState({ suggestLoading: false });
      });
  };

  editableClick = elem => {
    console.log(
      "editableClick() ",
      elem.button,
      elem.target.innerText,
      elem.target.tagName
    );

    if (elem.button !== 1) {
      //return false;
    }

    if (
      elem.target.tagName === "MARK" ||
      elem.target.tagName === "SPAN" ||
      elem.target.tagName === "B"
    ) {
      //this.suggestionMenuOpen(elem, elem.target.innerText);
    }
  };

  add2dictClick = (tip, self) => {
    var wordCorrectClass = document.getElementsByClassName("wordCorrectClass");

    for (var i = 0; i < wordCorrectClass.length; i++) {
      var anchor = wordCorrectClass[i];
      anchor.onclick = function(e) {
        tip.hide();
        self.setState({ dialogOpen: true });
      };
    }
  };

  async tfJSModelLoad() {
    //const tf = require("@tensorflow/tfjs");
    // const modelUrl = HOSTNAME + "/tfjs_model/model.json";
    // const model = await tf.loadLayersModel(modelUrl);
    //const model = await tf.loadLayersModel("indexeddb://tfjs-model");
    //await model.save('downloads://tfjs-model');
    //await model.save('localstorage://tfjs-model');
    //await model.save('indexeddb://tfjs-model');
    // const warmupResult = model.predict(
    //   tf.tensor([[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]])
    // );
    // warmupResult.dataSync();
    // warmupResult.dispose();
    // this.setState({ modelState: model });
    // Warmup the model before using real data.
    //const warmupResult = model.predict(tf.tensor([[10, 20, 30]]));
    //warmupResult.dataSync();
    //warmupResult.dispose();
    // The second predict() will be much faster
    //const result = model.predict(tf.tensor([[20, 30, 40]]));
    //console.log("prediction => ", result, result.dataSync(), result.arraySync());
    //result.array().then(array => console.log("array()", array));
    //result.data().then(data => console.log(data));
  }

  instantiateQuill() {
    let self = this;

    //$( ".ql-toolbar" ).remove();
    removeElementsByClass("ql-toolbar");

    var quill_options = {
      //debug: "info",
      modules: {
        //toolbar: '#quill-toolbar',
        // toolbar: {
        //   container: toolbarOptions //null
        //   //handlers: { 'italic' : function(hl){}}
        // },
        toolbar: false,
        keyboard: { bindings: self.state.keyboardType ? {} : assameseBindings }
      },
      placeholder: "Type or Copy-Paste - ইয়াত লিখক",
      //readOnly: true,
      theme: "snow" //bubble
    };

    var quill = new Quill("#quill-editor", quill_options);
    //quill.setText("Pre-trained text TensorFlow.js text. অসমীয়া ভাষাৰ । গণশক্তি হয় ১৯৬৬ 19.66 চনত");
    // quill.setContents([
    //   { insert: "whats " },
    //   { insert: "up ", attributes: { color: "red" } },
    //   { insert: "hello! ", attributes: { bold: true } },
    //   { insert: "world hello world hello- world hello! world" },
    //   { insert: "\n" }
    // ]);

    quill.once("text-change", function() {
      //console.log("First text change!");
      if (self.state.firstQuillType === false) {
        //self.setState({ firstQuillType: true, suggestLoading: true });
      }
      //Warmup the model before using real data.
    });

    quill.on("editor-change", function(eventName, ...args) {
      if (eventName === "text-change" || eventName === "selection-change") {
        // args[0] will be delta
        //log(chars2Num(lastWord(quill.getText())));
        //log(args)
        //log(args[1].ops[0].insert/delete)

        clearTimeout(self.time_out);
        self.time_out = setTimeout(() => {
          var range = quill.getSelection();
          if (range === null) return;

          const index = range.index;
          //console.log("index => ", index);
          self.setState({ quillCursorIndex: index });

          if (eventName === "text-change") {
            //self.setState({ firstQuillType: true });
          }

          let quillText = quill.getText();
          //console.log(quillText);
          quillText = quillText.substring(0, quillText.length - 1);
          self.setState({ inputText: quillText });

          const typedWordAndIndex = getWordOnCursor(quillText, index);

          const typedWord = typedWordAndIndex[0];
          const startIndex = typedWordAndIndex[1];
          const endIndex = typedWordAndIndex[2];

          //console.log(typedWord, startIndex, endIndex);
          //log(chars2Num(typedWord));

          self.setState({
            wordStartIndex: startIndex,
            wordEndIndex: endIndex,
            clickedWord: typedWord
          });

          return;

          if (typedWord.length < 1 || typedWord.length > 50) return;

          self.setState({ suggestLoading: true });

          //get suggestions from server
          FetchData("/suggest", {
            token:
              localStorage.getItem("auth_token") === null
                ? ""
                : localStorage.getItem("auth_token"),
            word: typedWord,
            mode: self.state.keyboardType
          })
            .then(result => {
              //console.log("/suggest", result);

              let jsonResult = JSON.parse(JSON.stringify(result));
              //console.log(jsonResult);
              self.setState(
                {
                  suggestedWords: [""].concat(jsonResult),
                  suggestLoading: false
                },
                () => {}
              );
            })
            .catch(error => {
              //alert(error);
              //console.log("/suggest", error);
              self.setState({ suggestLoading: false });
            });

          return;

          //The second predict() will be much faster
          // const result = self.state.modelState.predict(
          //   tf.tensor([chars2Num(typedWord)])
          // );

          //console.log("prediction => ", result, result.dataSync(), result.arraySync());
          //console.log("prediction => ", result.arraySync());

          //result.array().then(array => {});

          //log(result.data())

          //result.data().then(data => {});
          //result.dispose()

          self.setState({
            //tabSuggestionWord: 0,
            suggestedWords: [
              ...new Set([
                "",
                Math.random().toString(),
                Math.random().toString(),
                Math.random().toString(),
                "abc",
                "def",
                "xyz"
              ])
            ] //lastWord('text')
          });

          //console.log(tf.memory());
        }, 300); //Timer ends here

        //log(getWordOnCursor());
        //log(new Date().getTime());

        /*
        var range = quill.getSelection();
        if (range) {
          if (range.length == 0) {
            console.log("User cursor is at index", range.index);
          } else {
            var text = quill.getText(range.index, range.length);
            console.log("User has highlighted: ", text);
          }
        } else {
          console.log("User cursor is not in editor");
        }
        */
      }
      /*
      else if (eventName === "selection-change") {
        // args[0] will be old range

        if (args[2] === "user") {
          //log("click/cursor");
          //log(args)

          if (args[0] !== null && args[0].index !== null) {
            const typedWordAndIndex = getWordOnCursor(
              quill.getText(),
              args[0].index
            );
            log(typedWordAndIndex[0]);
          }
        }
      }
*/
    });

    //const letters = "abcdefghijklmnopqrstuvwxyz".split("");
    //let alphabet;
    //for (alphabet of letters) {}

    // quill.keyboard.addBinding(
    //   {
    //     key: "k"
    //     //altKey: true
    //     //shiftKey: true,
    //     //shortKey: true
    //   },
    //   function(range, context) {
    //     //console.log("key binding", range, context);
    //     quill.insertText(range, "ক");

    //     return false;
    //   }
    // );

    quill.keyboard.addBinding(
      {
        key: 27
      },
      function(range, context) {
        self.setState({ tabSuggestionWord: 0 });
        return false;
      }
    );

    quill.keyboard.bindings[9].unshift({
      key: 9,
      handler: function(range) {
        self.setState({
          //suggestedWords: [lastWord(quill.getText()), 'word1', 'word2', 'word3'],
          tabSuggestionWord:
            self.state.tabSuggestionWord < self.state.suggestedWords.length - 1
              ? self.state.tabSuggestionWord + 1
              : 0
        });
        return false;
      }
    });

    quill.keyboard.bindings[32].unshift({
      key: 32,
      handler: function(range) {
        if (self.state.tabSuggestionWord === 0) {
        } else if (self.state.wordStartIndex === self.state.wordEndIndex) {
          quill.insertText(
            self.state.wordStartIndex, //range,
            self.state.suggestedWords[self.state.tabSuggestionWord]
          );
        } else {
          quill.deleteText(
            self.state.wordStartIndex,
            self.state.wordEndIndex - self.state.wordStartIndex
          );

          quill.insertText(
            self.state.wordStartIndex, //range,
            self.state.suggestedWords[self.state.tabSuggestionWord]
          );
        }

        self.setState({
          //suggestedWords: [lastWord(quill.getText()), 'word1', 'word2', 'word3'],
          tabSuggestionWord: 0
        });
        return true;
      }
    });

    //to prevent pasting of HTML content
    quill.clipboard.addMatcher(Node.ELEMENT_NODE, function(node, delta) {
      //var plaintext = $(node).text();
      var plaintext = node.innerText;
      return new Delta().insert(plaintext);
    });

    this.setState({ quillEditorState: quill }, () => {
      //this.state.quillEditorState.focus();
      this.state.quillEditorState.setSelection(this.state.quillCursorIndex, 0);
    });
  }

  componentDidMount() {
    //tippy('span', { content: "I'm a tooltip!" })
    let self = this;

    // $(".editableClass").contextmenu(function(e) {
    //   e.preventDefault();
    //   console.log("right click");
    //   self.suggestionMenuOpen(e, e.target.innerText);
    // });

    //window.onload = function () {
    //rangy.init()
    //}

    const containerElement = document.getElementById("simpleEditable");

    if (this.state.rangyPrevState !== null) {
      //rangy.getSelection().restoreCharacterRanges(containerElement, this.state.rangyPrevState);
    }

    if (
      localStorage.getItem("user_status") !== null ||
      localStorage.getItem("user_status") === "logged_in"
    ) {
      // tippy("#simpleEditable", {
      //   target: ".redUnderline",
      //   content: document.getElementById("tippydiv").innerHTML,
      //   allowHTML: true,
      //   arrow: true,
      //   //hideOnClick: true,
      //   //touchHold: true,
      //   flip: false,
      //   touch: true,
      //   theme: "light-border",
      //   animation: "shift-away",
      //   animateFill: false,
      //   interactive: true,
      //   placement: "bottom",
      //   //delay: [300, 300],
      //   //distance: 0,
      //   //livePlacement: false,
      //   trigger: "click", //mouseenter focus click
      //   onShow: function(tip) {
      //     tip.setContent(document.getElementById("tippydiv").innerHTML);

      //     //alert(word)
      //     self.setState({
      //       //menuOpen: !state.menuOpen,
      //       //inputText: word,
      //       //clickedWord: word,
      //       //suggestAnchor: e.target, //e.currentTarget,
      //       openSuggest: true,
      //       //suggestedWords: [],

      //       suggestLoading: true
      //     });

      //     //return;

      //     FetchData("/suggest", {
      //       token:
      //         localStorage.getItem("auth_token") === null
      //           ? ""
      //           : localStorage.getItem("auth_token"),
      //       //email: localStorage.getItem("user_mail") === null ? "" : localStorage.getItem("user_mail"),
      //       word: clearWord(self.state.clickedWord)
      //     })
      //       .then(result => {
      //         console.log("/suggest", result);

      //         let jsonResult = JSON.parse(JSON.stringify(result));
      //         //console.log(jsonResult)
      //         self.setState(
      //           { suggestedWords: jsonResult, suggestLoading: false },
      //           () => {
      //             tip.setContent(document.getElementById("tippydiv").innerHTML);

      //             var wordSuggestion = document.getElementsByClassName(
      //               "wordSuggestion"
      //             );
      //             for (var i = 0; i < wordSuggestion.length; i++) {
      //               var anchor = wordSuggestion[i];
      //               anchor.onclick = function(e) {
      //                 tip.hide();
      //                 //alert(e.target.innerText)
      //                 let textState = self.state.title;
      //                 textState = textState.replace(
      //                   self.state.clickedWord,
      //                   e.target.innerText
      //                 );
      //                 self.state.suggestAnchor.innerText = e.target.innerText;

      //                 //self.setState({title: textState})

      //                 document.getElementById("input-length").innerHTML =
      //                   document.getElementById("simpleEditable").innerText
      //                     .length + " / 3000";
      //                 self.doSearch();
      //               };
      //             }

      //             self.add2dictClick(tip, self);

      //             //$(".wordSuggestion").click(function (e) {
      //             //  alert('jkdshfjksfhdjk')
      //             //})
      //           }
      //         );
      //       })
      //       .catch(error => {
      //         //alert(error);
      //         console.log("/suggest", error);
      //         self.setState({ suggestLoading: false });

      //         self.add2dictClick(tip, self);
      //       });

      //     //self.add2dictClick(tip, self);
      //     setTimeout(function() {
      //       self.add2dictClick(tip, self);
      //     }, 200);
      //   }
      // });

      this.instantiateQuill();
    }

    let shiftTime = 0;
    window.addEventListener("keydown", function(e) {
      //console.log('keycode', e.keyCode, e.shiftKey)

      if (!e.shiftKey || e.keyCode !== 16) {
      } else if (e.shiftKey && new Date().getTime() - shiftTime < 300) {
        //if (e.shiftKey && e.ctrlKey) {

        self.setState({ keyboardType: !self.state.keyboardType }, () => {
          self.instantiateQuill();
        });
        shiftTime = new Date().getTime();
      } else {
        shiftTime = new Date().getTime();
      }
    });

    //this.tfJSModelLoad();

    //to disable right-click menu
    document.oncontextmenu = function(e) {
      //console.log(e.target.className)
      if (e.target.className === "MuiChip-label") {
        return false;
      } else {
        return true;
      }
    };
  }

  handleClickAway = () => {
    this.setState({
      menuOpen: false
    });
  };

  handleSnackClose = () => {
    this.setState(state => ({
      openSnack: false
    }));
  };

  logOut = () => {
    //localStorage.setItem("user_status","logged_out")
    localStorage.clear();
    this.setState({
      redirect: true
    });

    firebase
      .auth()
      .signOut()
      .then(
        function() {
          // Sign-out successful.
          console.log("firebase signed out");
        },
        function(error) {
          // An error happened.
        }
      );
  };

  componentWillMount() {
    console.log(
      "MyGrid.js componentWillMount ",
      this.state.redirect,
      localStorage.getItem("user_status")
    );

    if (
      localStorage.getItem("user_status") === null ||
      localStorage.getItem("user_status") !== "logged_in"
    ) {
      this.setState({ redirect: true });
    }
  }

  componentWillUpdate(nextProps, nextState, nextContext) {}

  copyText = () => {
    const elem = document.getElementById("simpleEditable");

    //if (this.state.inputText.length < 1) {
    if (elem.innerText.length < 1) {
      this.setState({
        openSnack: true,
        snackMessage: "Nothing to copy."
      });
      return false;
    }

    //copyElemText(this.state.inputText)
    copyElemText(elem.innerText);

    //var range = rangy.createRange();
    //range.selectNodeContents(elem);
    //var sel = rangy.getSelection();
    //sel.removeAllRanges();
    //sel.addRange(range);

    //alert('copy')
    //document.getElementById("input-textarea").select();
    //document.execCommand("copy");
    //this.setState({
    //openSnack: true,
    //snackMessage: "Text copied."
    //});
  };

  onSearch = event => {
    const searchTerm = event.currentTarget.value;
    this.setState({
      search_term: searchTerm
    });
  };

  handleContentChange = event => {
    let targetValue = event.target.value;
    //console.log('html : ', $("#ContentEditableId").text())

    let contenteditable = document.querySelector("[contenteditable]");
    //let text = contenteditable.textContent;

    let elementById = document.getElementById("ContentEditableId");
    let text = elementById.innerText;

    //console.log("contenteditable.textContent => ",elementById.innerText)
    //console.log("event.target.value => ", targetValue)
    //console.log("innerHTML => ", elementById.innerHTML)

    //positioning cursor

    //let savedSel = rangy.getSelection().saveCharacterRanges(elementById);

    //this.setState({ rangyPrevState: savedSel });

    //this.setState({ openSuggest: false, html: buildEditableHtml(targetValue) });
    //this.setState({ html: typedText});

    this.setState({
      inputText: text,
      inputCharLength: text.length,
      inputWordsNum: countWords(text),
      wordsMap: stringToArray(text),

      //editorState: EditorState.createWithContent(ContentState.createFromText(typedText))
      //html: typedText //HTML

      serverResponse: [],

      openSuggest: false
    });

    //this.onnx_js()

    if (stringToArray(text).length > 100) {
      this.setState({
        //openSnack: true,
        //snackMessage: "Exceeded 100 words limit."
      });
    }

    if (text.length > 3000) {
      this.setState({
        openSnack: true,
        snackMessage: "Exceeded 3000 character limit."
      });
      return false;
    } else {
      this.setState({
        openSnack: false
      });
    }

    this.setState(
      {
        openSuggest: false,
        html: buildEditableHtml(targetValue, text, this.state.response)
      },
      () => {
        //rangy.getSelection().restoreCharacterRanges(elementById, savedSel);
      }
    );

    //elementById.focus()

    this.doSearch();
  };

  doSearch = () => {
    let self = this;

    //const elementById = document.getElementById("slateEditable")
    const elementById = document.getElementById("simpleEditable");

    let wordMap = stringToArray(elementById.innerText);

    let wrongWords = [];

    this.state.serverResponse.map(function(value, index, array) {
      if (value === 0) wrongWords.push(wordMap[index]);
    });

    //clog(this.state.serverResponse)
    clog(wrongWords);

    var regex = /[^\x00-\x7F]+/gim;

    // var instance = new mark(elementById);
    // instance.unmark();
    // instance.mark(
    //   //markRegExp
    //   //["hello", "world", "কম্পিউটাৰ"],
    //   //wrongWords,
    //   this.state.wrong_words,
    //   //regex,
    //   {
    //     element: "span",
    //     className: "redUnderline",
    //     accuracy: {
    //       value: "exactly", //"complementary",
    //       limiters: [",", "."]
    //     },
    //     noMatch: function(matchOrNot) {
    //       //clog(matchOrNot)
    //       //this.setState({noMatch: false})
    //     },
    //     done: function(matches) {
    //       clog(matches);
    //       matches > 0
    //         ? self.setState({ noMatch: false })
    //         : self.setState({ noMatch: true });
    //     }
    //   }
    // );

    return false;

    // var classApplierModule = rangy.modules.ClassApplier;
    // if (rangy.supported && classApplierModule && classApplierModule.supported) {
    //   //rangy.init()

    //   // Remove existing highlights
    //   //var range = rangy.createRange();

    //   var searchScopeRange = rangy.createRange();
    //   //searchScopeRange.selectNodeContents(document.body);
    //   searchScopeRange.selectNodeContents(document.body);

    //   var searchResultApplier;
    //   searchResultApplier = rangy.createClassApplier("redUnderline");
    //   searchResultApplier.undoToRange(searchScopeRange);

    //   var options = {
    //     caseSensitive: false,
    //     wholeWordsOnly: true,
    //     withinRange: searchScopeRange,
    //     direction: "forward" // This is redundant because "forward" is the default
    //   };

    //   // Create search term
    //   var searchTerm = this.state.title;

    //   if (searchTerm !== "") {
    //     searchTerm = new RegExp(searchTerm, "gim");

    //     // Iterate over matches
    //     while (searchScopeRange.findText(searchTerm, options)) {
    //       // range now encompasses the first text match
    //       //searchResultApplier.applyToRange(searchScopeRange);
    //       // Collapse the range to the position immediately after the match
    //       //searchScopeRange.collapse(false);
    //     }
    //   }
    // }
  };

  saveNote = () => {
    let self = this;
    const auth_token = localStorage.getItem("auth_token");

    if (this.state.inputText.length < 1) {
      this.setState({
        openSnack: true,
        snackMessage: "Please write something."
      });
      return false;
    }

    this.setState({ submitting: true });

    FetchData("/save_note", {
      id: auth_token,
      note: this.state.inputText,
      time: new Date().getTime()
    })
      .then(result => {
        console.log(result);
        self.setState({
          openSnack: true,
          snackMessage: "Note saved successfully."
        });
        self.setState({ submitting: false });
      })
      .catch(error => {
        self.setState({ submitting: false });
        self.setState({
          openSnack: true,
          snackMessage: "Problem saving note."
        });
      });

    return;

    // Add a new document in collection "cities"
    // fbdb
    //   .collection(auth_token)
    //   .doc(auth_token)
    //   .set({
    //     note: this.state.inputText,
    //     time: new Date()
    //   })
    //   .then(function() {
    //     console.log("Document successfully written!");
    //     self.setState({
    //       openSnack: true,
    //       snackMessage: "Saved successfully."
    //     });
    //     self.setState({ submitting: false });
    //   })
    //   .catch(function(error) {
    //     console.error("Error writing document: ", error);
    //     self.setState({ submitting: false });
    //   });

    // Add a new document with a generated id.
    fbdb
      .collection(auth_token)
      .add({
        note: this.state.inputText,
        time: new Date().getTime()
      })
      .then(function(docRef) {
        console.log("Document written with ID: ", docRef.id);
        self.setState({
          openSnack: true,
          snackMessage: "Saved successfully."
        });
        self.setState({ submitting: false });
      })
      .catch(function(error) {
        console.error("Error adding document: ", error);
        self.setState({
          openSnack: true,
          snackMessage: "Problem saving note."
        });
        self.setState({ submitting: false });
      });
  };

  spellCheckButtonClick = () => {
    //alert(this.state.html)
    //let contenteditable = document.querySelector("[contenteditable]");
    //let text = contenteditable.textContent;
    //alert(text);
    //this.setState({ html: typedText });

    const quillText = this.state.quillEditorState.getText();
    const quillContents = this.state.quillEditorState.getContents();

    let typedText = this.state.inputText;

    //console.log(typedText, io, typedText.length);
    let wordMap = stringToArray(typedText);
    //console.log('word array ', wordMap)
    let HTML = "";
    // for (var i = 0; i < wordMap.length; i++) {
    //   if (i % 5 === 0) {
    //     HTML = HTML + "<mark>" + wordMap[i] + "</mark>";
    //   } else {
    //     HTML = HTML + "<span>" + wordMap[i] + "</span>";
    //   }
    // }

    this.setState({
      //inputText: typedText,
      inputCharLength: typedText.length,
      inputWordsNum: countWords(typedText),
      wordsMap: stringToArray(typedText)

      //editorState: EditorState.createWithContent(ContentState.createFromText(typedText))
      //html: HTML
    });

    //this.onnx_js()

    if (wordMap.length < 1) {
      this.setState({
        openSnack: true,
        snackMessage: "Please write something.",
        submitting: false
      });
      return false;
    }

    if (stringToArray(typedText).length > 100) {
      this.setState({
        //openSnack: true,
        //snackMessage: "Exceeded 100 words limit."
      });
    }

    if (typedText.length > 3000) {
      this.setState({
        openSnack: true,
        snackMessage: "Exceeded 3000 character limit.",
        submitting: false
      });
      return false;
    } else {
      this.setState({
        openSnack: false
      });
    }

    //saving spell checks to database TODO
    // fbdb
    //   .collection("_checks_" + this.state.auth_token)
    //   .add({
    //     note: this.state.inputText,
    //     time: new Date()
    //   })
    //   .then(function(docRef) {
    //     console.log("Document written with ID: ", docRef.id);
    //   })
    //   .catch(function(error) {
    //     console.error("Error adding document: ", error);
    //   });

    // this.setState({
    //   openSnack: true,
    //   snackMessage: "This function is under developement."
    // });

    //return false;

    this.setState({
      submitting: true
    });

    FetchData("/spellcheck", {
      //email: localStorage.getItem("user_mail") === null ? "" : localStorage.getItem("user_mail"),
      token:
        localStorage.getItem("auth_token") === null
          ? ""
          : localStorage.getItem("auth_token"),
      text: typedText
    })
      .then(result => {
        console.log("/spellcheck", result);

        let jsonResult = JSON.parse(JSON.stringify(result));
        //console.log("/spellcheck", jsonResult.id);

        this.setState({
          serverResponse: jsonResult,
          submitting: false,
          response: result,
          wrong_words: wrong_words_array(this.state.inputText, jsonResult), //["php","code"]
          spell_checked: true
        });

        //this.doSearch();

        this.state.quillEditorState.updateContents(
          new Delta().retain(quillText.length, { color: "black" })
        );

        let indexRanges = {};
        //let wordLengths = [];

        this.state.wrong_words.forEach(wordtofind => {
          //log(wordtofind);
          let currentIndex = 0;

          while (true) {
            currentIndex = quillText.indexOf(wordtofind, currentIndex);
            if (currentIndex === -1) {
              break;
            }
            //indexRanges.push([currentIndex, wordtofind.length]);
            indexRanges[currentIndex] = wordtofind.length;
            //wordLengths.push(wordtofind.length)
            currentIndex += 1;
          }
        });

        log(indexRanges);

        //remove edited texts and setting it to default text
        //this.state.quillEditorState.setText(quillText);

        let deltaBuilder = new Delta();

        let retainLength = 0;
        Object.keys(indexRanges).forEach(key => {
          console.log(key, indexRanges[key], parseInt(key) - retainLength);

          deltaBuilder.retain(parseInt(key) - retainLength, { color: "black" });
          deltaBuilder.retain(indexRanges[key], { color: "red" });

          retainLength = parseInt(key) + indexRanges[key];
        });

        for (let iter = 0; iter < indexRanges.length; iter++) {
          //log(indexRanges[iter])
          //log(wordLengths[iter])
          //deltaBuilder.retain(indexRanges[iter] - retainLength, { color: "black" });
          //deltaBuilder.retain(wordLengths[iter], { color: "red" });
          //retainLength = indexRanges[iter] + wordLengths[iter];
        }

        this.state.quillEditorState.updateContents(deltaBuilder);
      })
      .catch(error => {
        //alert(error);
        console.log("/spellcheck", error);
        this.setState({ submitting: false });
      });
  };

  checkingProgress = () => {
    this.setState({ submitting: true });
    this.spellCheckButtonClick();
  };

  getWordMeaning = word => {
    this.setState({
      openSnack: true,
      snackMessage: word + " - Loading meaning..."
    });

    //fetching word meaning
    FetchData("/get_word_meaning", {
      id: localStorage.getItem("auth_token"),
      _word: word
    })
      .then(result => {
        this.setState({
          openSnack: true,
          snackMessage: word + " - " + result
        });
      })
      .catch(error => {
        this.setState({
          openSnack: true,
          snackMessage: "Problem connecting internet."
        });
      });
  };

  render() {
    const { classes } = this.props;
    const { vertical, horizontal } = this.state;
    let wordCount = -1;

    if (
      this.state
        .redirect /*|| localStorage.getItem("user_status") === "logged_in"*/
    ) {
      return (
        <Redirect to={"/"} />
        //<Route path={"/search"} component={MenuOptions}/>
      );
    }

    const CloseButton = (
      <IconButton
        size="small"
        onClick={() => {
          this.setState({ firstQuillType: false });
        }}
      >
        <CloseIcon color="secondary" style={{ fontSize: 15 }} />
      </IconButton>
    );

    return (
      <MuiThemeProvider theme={mui_theme}>
        <div className={classes.root}>
          <AppContext.Provider
            value={{
              state: this.state,
              actions: {
                hideSuggest: () => {
                  this.setState({
                    openSuggest: false
                  });
                },
                pickWord: pickedWord => {
                  alert(this.state.suggestAnchor);

                  //this.state.suggestAnchor.childNodes[0].innerText = pickedWord;
                  this.state.suggestAnchor.innerHTML = pickedWord;

                  //alert(this.myRef.current.innerText)

                  this.setState({
                    openSuggest: false,
                    //wordsMap: ['test']
                    //html: pickedWord
                    inputText: this.myRef.current.innerText
                  });
                },
                openSnackBar: snackMessage => {
                  this.setState({
                    openSnack: true,
                    snackMessage: snackMessage
                  });
                },
                dialogOpenClose: openOrNot => {
                  this.setState({
                    dialogOpen: openOrNot
                  });
                }
              }
            }}
          >
            <div>
              <MyAppBar actionfunc={this.logOut} />
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} className="loginBoxContainer">
                  <MyCard />
                  {/* <Typography color="secondary" gutterBottom variant="body1">
                    Aakhor is under developement now. Play our word game and
                    make money.
                  </Typography>

                  <Button component={Link} to={"/word-game"} variant="outlined">
                    <GameIcon style={{ marginRight: 10 }} />
                    Play game
                  </Button> */}

                  <div className="dividerMargin" />

                  {/* <Typography gutterBottom>
                    Search word - শব্দ সন্ধান
                  </Typography>
                  <MyAutoSuggest /> */}

                  <div className="dividerMargin">{/* <Divider /> */}</div>

                  {/*<List>*/}
                  {/*<ListItem>*/}
                  {/*<KeyboardIcon/>*/}
                  {/*<ListItemText*/}
                  {/*primary="তলত অসমীয়াত লিখক"*/}
                  {/*secondary="Enter Assamese text below"*/}
                  {/*/>*/}
                  {/*</ListItem>*/}
                  {/*</List>*/}

                  {/* <Typography variant="h5">তলৰ বাকছটোত অসমীয়া লিখক</Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Enter Assamese text below
                </Typography> */}

                  {/*<div id={"ContentEditableId"} contentEditable={true}>edit</div>*/}

                  {/*{StateLessWidget()}*/}
                  {/* <Typography gutterBottom>
                    Copy-Paste or type below - অসমীয়াত লিখক
                  </Typography> */}

                  {/* <ContentEditable
                    id="ContentEditableId"
                    //onClick={elem => this.editableClick(elem)}
                    className={"editableClass resultContainer hideClass"}
                    html={this.state.html} // innerHTML of the editable div
                    disabled={false} // use true to disable edition
                    onChange={this.handleContentChange} //handle innerHTML change
                    //tagName={"pre"}
                    //onMouseUp={() => {rangy.getSelection().expand("word", { trim: true });}}
                  /> */}

                  <div id="tippydiv" className={"hideClass"}>
                    {/*<strong>{clearWord(this.state.clickedWord)}</strong>*/}
                    <WordSuggest />
                  </div>

                  {/*<Editor*/}
                  {/*id={"slateEditable"}*/}
                  {/*value={this.state.value}*/}
                  {/*onChange={this.onSlateChange}*/}
                  {/*onKeyDown={this.onKeyDown}*/}
                  {/*renderNode={this.renderNode}*/}
                  {/*placeholder={"ইয়াত অসমীয়াত লিখক (Enter assamese here)"}*/}
                  {/*/>*/}

                  {/*<Typography variant={"h6"} gutterBottom>*/}
                  {/*তলত অসমীয়াত লিখক*/}
                  {/*Type Assamese below*/}
                  {/*</Typography>*/}

                  <ReactContentEditable
                    id={"simpleEditable"}
                    html={this.state.title}
                    contentEditable="plaintext-only"
                    className="content-class hideClass"
                    //tagName="h1"
                    //onChange={this.contentChange}
                    onClick={() => {
                      this.setState({ title: "" });
                    }}
                    //onChange={() => {}}
                    onChange={e => this.contentKeyUp(e)}
                    onKeyPress={() => {
                      clearTimeout(this.time_out);
                      this.setState({ submitting: false });
                      this.time_out = setTimeout(
                        () => this.checkingProgress(),
                        3000
                      );
                    }}
                    onMouseOver={e => this.contentMouseOver(e)}
                    //onClick={(e) => this.contentMouseOver(e)}
                    onKeyUp={e => this.contentKeyUp(e)}
                  />

                  <Dialog
                    open={this.state.openKeyDialog}
                    onClose={() => this.setState({ openKeyDialog: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll={"body"}
                    fullWidth={true}
                  >
                    <DialogTitle>
                      {"Phonetic key map"}
                      {/* <Typography>Press double shift</Typography> */}
                    </DialogTitle>
                    <DialogContent dividers={false}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Alphabet</TableCell>
                            <TableCell align="right">Keys</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {KEY_MAP.map((value, index_no) => {
                            return (
                              <TableRow key={index_no}>
                                <TableCell component="th" scope="row">
                                  {value[1]}
                                </TableCell>
                                <TableCell align="right">{value[0]}</TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={() => this.setState({ openKeyDialog: false })}
                        color="primary"
                      >
                        close
                      </Button>
                    </DialogActions>
                  </Dialog>

                  <Box mb={1}>
                    <Tooltip title="Key Map" placement="top">
                      <Fab
                        size={"small"}
                        color="primary"
                        aria-label="add"
                        onClick={() => this.setState({ openKeyDialog: true })}
                        style={{ marginRight: "10px" }}
                      >
                        <KeyboardIcon />
                      </Fab>
                    </Tooltip>

                    <Tooltip title="Change keyboard type" placement="top">
                      <FormControlLabel
                        value="end"
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.keyboardType}
                          />
                        }
                        label={
                          <Box>
                            <div>
                              <Typography
                                variant="caption"
                                className="noselect"
                              >
                                CHANGE KEYBOARD
                              </Typography>
                            </div>
                            <Typography
                              variant={"caption"}
                              color={"textSecondary"}
                              className="noselect"
                            >
                              ASSAMESE / DEFAULT (DOUBLE SHIFT)
                            </Typography>
                          </Box>
                        }
                        labelPlacement="end"
                        onChange={e => {
                          this.setState(
                            { keyboardType: e.target.checked },
                            () => {
                              this.instantiateQuill();
                            }
                          );
                        }}
                      />
                    </Tooltip>
                  </Box>

                  {this.state.firstQuillType && (
                    <div className="floatSuggest">
                      {this.state.clickedWord.length < 1 && (
                        <Box
                          paddingLeft={1}
                          paddingRight={1}
                          fontWeight="fontWeightBold"
                          fontSize={14}
                        >
                          <Typography variant="overline">
                            TYPE and CLICK WORD
                          </Typography>
                          {CloseButton}
                        </Box>
                      )}
                      {this.state.clickedWord.length > 0 && (
                        <Box paddingLeft={1} paddingRight={1}>
                          <span style={{ marginRight: "5px" }}>
                            <mark>{this.state.clickedWord}</mark>
                          </span>
                          <Button
                            color="primary"
                            size="small"
                            onClick={() => {
                              this.getWordMeaning(this.state.clickedWord);
                            }}
                          >
                            Meaning
                          </Button>
                          <Button
                            color="primary"
                            size="small"
                            onClick={() => {
                              this.setState({ dialogOpen: true });
                            }}
                          >
                            Add to dictionary
                          </Button>
                          {CloseButton}
                        </Box>
                      )}

                      {this.state.suggestedWords.map((word, index) => {
                        if (index === 0) {
                          return <div className="hideClass" key={index} />;
                        }
                        return (
                          <Chip
                            key={index}
                            variant="default"
                            title={word}
                            color={
                              index === this.state.tabSuggestionWord
                                ? "primary"
                                : "default"
                            }
                            className="wordSuggestion"
                            label={shortenWord(word)}
                            clickable
                            onContextMenu={() => {
                              this.getWordMeaning(word);
                            }}
                            onClick={() => {
                              //alert(word)

                              this.state.quillEditorState.deleteText(
                                this.state.wordStartIndex,
                                this.state.wordEndIndex -
                                  this.state.wordStartIndex
                              );

                              this.state.quillEditorState.insertText(
                                this.state.wordStartIndex, //range,
                                word + " "
                              );

                              this.setState({
                                //suggestedWords: [lastWord(quill.getText()), 'word1', 'word2', 'word3'],
                                tabSuggestionWord: 0
                              });
                            }}
                          />
                        );
                      })}
                    </div>
                  )}

                  {this.state.firstQuillType && (
                    <Box marginTop={1}>
                      <Typography variant="caption" color="textSecondary">
                        {this.state.suggestedWords.length > 0 &&
                          !this.state.suggestLoading &&
                          "Press Tab and Space, Escape to deselect suggestions"}
                        {this.state.suggestLoading && "Searching..."}
                      </Typography>
                    </Box>
                  )}

                  <div className="quill-container">
                    {/* <div id="quill-toolbar" /> */}
                    <div id="quill-editor" />
                  </div>

                  {this.state.submitting && <LinearProgress />}

                  <div className={"marginTop10"}>
                    {/*<Typography variant={"body1"}>*/}
                    {/*Use desktop for better experiance.*/}
                    {/*</Typography>*/}

                    {this.state.spell_checked && (
                      <Box
                        textAlign="right"
                        p={1}
                        borderRight={2}
                        borderColor="red"
                      >
                        <Typography
                          color="secondary"
                          variant="caption"
                          align="right"
                        >
                          {this.state.wrong_words.length} unknown word
                          {this.state.wrong_words.length > 0 ? "s" : ""}.
                        </Typography>
                      </Box>
                    )}
                    {/* <Box textAlign="right">
                      {!this.state.noMatch && (
                        <Typography
                          color="secondary"
                          variant="caption"
                          align="right"
                        >
                          Underlined words are not in our dictionary. Click
                          words for suggestions.
                        </Typography>
                      )}
                      {this.state.noMatch && (
                        <Typography
                          color="secondary"
                          variant="caption"
                          align="right"
                        >
                          Type and press SPELLCHECK
                        </Typography>
                      )}
                    </Box> */}
                  </div>

                  <DialogActions>
                    <Tooltip title="Text length" placement="top">
                      <Typography variant={"caption"}>
                        <span id="input-length" className={"greenClass"}>
                          {this.state.inputText.length} / 3000
                        </span>
                      </Typography>
                    </Tooltip>

                    {/*<Chip*/}
                    {/*label={this.state.inputCharLength + " / " + "3000"}*/}
                    {/*variant="outlined"*/}
                    {/*color={"secondary"}*/}
                    {/*/>*/}

                    {/* <Typography color={"secondary"} className={"noselect"}>
                      {/* words: {this.countWords(this.state.inputText)} / 100 & characters: {this.state.inputCharLength} / 1000 }
                      words: {this.state.inputWordsNum} / 100 , chars{" "}
                      {this.state.inputCharLength} / 3000
                    </Typography> */}

                    {/* <Tooltip title="Copy text" placement="top">
                      <IconButton
                        color="default"
                        aria-label="Copy text"
                        onClick={() => this.copyText()}
                      >
                        <CopyIcon fontSize={"small"} />
                      </IconButton>
                    </Tooltip> */}

                    <Tooltip title="Save note" placement="top">
                      {/* <IconButton
                        color="default"
                        aria-label="Save note"
                        onClick={() => this.saveNote()}
                      >
                        <SaveIcon fontSize={"small"} />
                      </IconButton> */}
                      <Button
                        color="default"
                        onClick={() => this.saveNote()}
                        size="small"
                      >
                        Save note
                      </Button>
                    </Tooltip>

                    {/*this.state.submitting && (
                      <Button color="default" variant="contained" disabled>
                        SpellCheck
                      </Button>
                    )}
                    {this.state.submitting === false && (
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={this.spellCheckButtonClick}
                      >
                        SpellCheck
                      </Button>
                    )*/}

                    {/* <Tooltip title="Save note" placement="top">
                      <Button
                        color="primary"
                        variant="outlined"
                        onClick={this.saveNote}
                      >
                        Save
                      </Button>
                    </Tooltip> */}
                  </DialogActions>

                  {/*<div id="loader" />*/}
                  {/*<div id="firebaseui-auth-container" />*/}

                  <MyNotes />

                  <SupportPage />

                  <Payment />

                  <MyFooter />

                  {/* <DialogActions className={"hideClass"}>
                                        <TextField
                                            id="search-dict"
                                            name="search-dict-name"
                                            type="text"
                                            fullWidth
                                            defaultValue={this.state.search_term}
                                            onChange={this.onSearch}
                                            placeholder={"Type word here"}
                                        />
                                </DialogActions> */}
                </Grid>
                <Grid item xs={12} className={"boxContainer hideClass"}>
                  {/* <LoginPage /> */}
                  {/*<Editor*/}
                  {/*editorState={this.state.editorState}*/}
                  {/*onChange={this.onChange}*/}
                  {/*handleKeyCommand={this.handleKeyCommand}*/}
                  {/*autocomplete="off"*/}
                  {/*autocorrect="off"*/}
                  {/*autocapitalize="off"*/}
                  {/*spellcheck="false"*/}
                  {/*/>*/}
                </Grid>

                <Grid item xs={12} sm={6} className={"hideClass"}>
                  {/* <MyCard /> */}
                  <div className={"boxContainer leftBoxContainer"}>
                    <List>
                      <ListItem>
                        <KeyboardIcon />
                        <ListItemText
                          primary="তলত অসমীয়াত লিখক"
                          secondary="Enter Assamese text below"
                        />
                      </ListItem>
                    </List>

                    <TextField
                      id="input-textarea"
                      placeholder="Enter text here"
                      multiline
                      //onSelect={(e) => {console.log(window.getSelection())}}
                      margin="normal"
                      variant={"outlined"}
                      fullWidth
                      onChange={e => this.handleChange(e, "input")}
                      value={this.state.inputText}
                    />

                    <DialogActions>
                      <Chip
                        label={this.state.inputCharLength + " / " + "3000"}
                        variant="outlined"
                        color={"secondary"}
                      />

                      {/* <Typography color={"secondary"} className={"noselect"}>
                      {/* words: {this.countWords(this.state.inputText)} / 100 & characters: {this.state.inputCharLength} / 1000 }
                      words: {this.state.inputWordsNum} / 100 , chars{" "}
                      {this.state.inputCharLength} / 3000
                    </Typography> */}

                      <Tooltip title="Copy text" placement="top">
                        <IconButton
                          color="secondary"
                          aria-label="Copy text"
                          onClick={() => this.copyText()}
                        >
                          <CopyIcon fontSize={"small"} />
                        </IconButton>
                      </Tooltip>
                      {this.state.submitting && (
                        <Button color="default" variant="contained" disabled>
                          Checking...
                        </Button>
                      )}
                      {this.state.submitting === false && (
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={this.spellCheckButtonClick}
                        >
                          SpellCheck
                        </Button>
                      )}
                    </DialogActions>

                    <div className="hideClass">
                      <DialogActions className="hideClass">
                        <IconButton color="primary" aria-label="Keyboard">
                          <KeyboardIcon />
                        </IconButton>
                        <input
                          accept="image/*"
                          className={classes.inputStyle}
                          id="icon-button-file"
                          type="file"
                        />
                        <label htmlFor="icon-button-file">
                          <IconButton color="primary" component="span">
                            <PhotoCamera />
                          </IconButton>
                        </label>
                        <Button
                          variant="contained"
                          aria-label="Translate"
                          color="primary"
                        >
                          Translate
                        </Button>
                      </DialogActions>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} className={"hideClass"}>
                  <div className={"boxContainer rightBoxContainer"}>
                    <List>
                      <ListItem>
                        <HighlightIcon />
                        <ListItemText
                          primary="ফলাফল"
                          secondary="Check result below"
                        />
                      </ListItem>
                    </List>

                    <div className="resultContainer" ref={this.myRef}>
                      {(countWords(this.state.inputText) < 1 ||
                        this.state.serverResponse.length < 1) && (
                        <Typography
                          component="p"
                          variant="subtitle1"
                          color="textSecondary"
                        >
                          ...
                        </Typography>
                      )}

                      {this.state.wordsMap.map(word => {
                        if (this.state.serverResponse.length < 1) {
                          return null;
                        }
                        //{this.state.inputText.split(" ").map(word => {
                        wordCount++;
                        //console.log('word : ', word)
                        if (word.length < 1) {
                          return null;
                        }
                        return (
                          <WordComponent
                            key={wordCount}
                            //word={this.state.inputText.split(" ")[wordCount]}
                            wordresult="secondary"
                            word={word}
                            isWrong={this.state.serverResponse[wordCount]}
                            menuopen={this.suggestionMenuOpen}
                          />
                        );
                      })}
                    </div>

                    {/*<WordSuggest/>*/}

                    <ClickAwayListener onClickAway={this.handleClickAway}>
                      <div>
                        {this.state.menuOpen ? (
                          <Paper>
                            <MenuList>
                              <MenuItem>Spell check</MenuItem>
                              <MenuItem>Dictionary</MenuItem>
                              <MenuItem>Improve result</MenuItem>
                            </MenuList>
                          </Paper>
                        ) : null}
                      </div>
                    </ClickAwayListener>

                    {/* <TextField
                id="output-textarea"
                label="Assamese"
                placeholder="Type here"
                multiline
                margin="normal"
                variant="outlined"
                fullWidth
                onChange={e => this.handleChange(e, "output")}
                value={this.state.outputText}
              /> */}

                    <CardActions>
                      {/* <IconButton color="primary" aria-label="Spell check">
                      <SpellIcon />
                    </IconButton> */}

                      {/* <Button size="small" color="primary" variant="outlined">
                      Improve result
                    </Button> */}
                    </CardActions>

                    <DialogActions>
                      <Tooltip title="Copy text" placement="top">
                        <IconButton
                          color="secondary"
                          aria-label="Copy text"
                          onClick={() => this.copyText()}
                        >
                          <CopyIcon fontSize={"small"} />
                        </IconButton>
                      </Tooltip>
                    </DialogActions>
                  </div>
                </Grid>

                {/* <Grid item xs={12} sm={6} className={classes.gridStyle}>
            <Typography color={"secondary"}>
              {this.state.outputCharLength}/1000
            </Typography>
          </Grid> */}

                {/* <div>
              <div id="firebaseui-auth-container" />
              <div id="loader">Loading...</div>
              <MyCard />
            </div>

            <div>
              <img src="https://chart.googleapis.com/chart?cht=qr&chl=https%3A%2F%2Finvisionweb.in%2Ftranslator&chs=180x180&choe=UTF-8&chld=L|2" />
            </div> */}
              </Grid>
            </div>

            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={this.state.openSnack}
              onClose={this.handleSnackClose}
              ContentProps={{
                "aria-describedby": "message-id"
              }}
              message={<span id="message-id">{this.state.snackMessage}</span>}
            />

            <MyDialog />
          </AppContext.Provider>
        </div>
      </MuiThemeProvider>
    );
  }
}

CenteredGrid.propTypes = {
  classes: PropTypes.object.isRequired
};

//FireBaseUI.start('#firebaseui-auth-container', FireBaseUIConfig);

/* firebase.auth().signOut().then(function() {
          // Sign-out successful.
        }).catch(function(error) {
          // An error happened.
        }); */

export default withStyles(styles)(CenteredGrid);
